module.exports = __webpack_public_path__ + "static/media/file-type-pdf.570fd0b4.svg";